<html>
    <head>
        <title>CCDATOS | Cambiar contraseña</title>
    </head>
    <body>
        <h1 class="title">Cambiar contraseña</h1>
        <mat-card>
            <mat-card-header>
                <!--<mat-card-title class="text">Ayuda con contraseña</mat-card-title>-->
                <mat-card-content style="padding: 5px 0px 25px 0px;">Introduzca una nueva contraseña</mat-card-content>
            </mat-card-header>

            <mat-card-content>
                <form [formGroup]="signin">
                    <!--<mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Email</mat-label>
                        <input matInput 
                            placeholder="nombre@ejemplo.com" 
                            formControlName="email"
                            autocomplete="email"
                            required>
                        <mat-icon matPrefix>person</mat-icon>
                        <mat-error *ngIf="emailError.invalid">{{getErrorMessageEmail()}}</mat-error>
                    </mat-form-field>-->

                    <div class="error-container">
                        <div *ngIf= errorVisible class="error-message">
                            {{ errorMessage }}
                        </div>
                    </div>

                    <form [formGroup]="signin" style="width: 100%;">
                        <mat-form-field class="input-container2">
                            <mat-label class="label-text">Contraseña</mat-label>
                            <input matInput placeholder="Introduzca la nueva contraseña" [type]="hide ? 'password' : 'text'" formControlName="password" required>
                            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <!--<mat-error *ngIf="passwordError.invalid">{{getErrorMessagePassword()}}</mat-error>-->
                        </mat-form-field>
                    </form>

                    <div *ngIf="errorNingunaContrasenha" class="error-container" style="margin-bottom: 15px; margin-top: -10px; margin-left: 5%;">
                        <span style="color: rgba(255, 0, 0, 0.993); font-size: 14px;">
                            El campo contraseña no puede estar vacío
                        </span>
                    </div>
            
                    <form [formGroup]="signin" style="width: 100%;">
                        <mat-form-field class="input-container2" style="margin-bottom: 25px;">
                            <mat-label class="label-text">Repite contraseña</mat-label>
                            <input matInput placeholder="Repita la contraseña" [type]="hideR ? 'password' : 'text'" formControlName="passwordR" required>
                            <mat-icon matSuffix (click)="hideR = !hideR">{{hideR ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <!--<mat-error *ngIf="passwordError.invalid">{{getErrorMessagePasswordR()}}</mat-error>-->
                        </mat-form-field>
                    </form>

                    <div>

                        <div *ngIf="errroContrasenhaPequenha" class="error-container" style="margin-bottom: 10px; margin-top: -15px; margin-left: 5%;">
                            <span style="color: rgba(255, 0, 0, 0.993); font-size: 14px;">
                                La contraseña debe tener al menos 8 caracteres.
                            </span>
                        </div>

                        <div *ngIf="errorContrasenhaIguales" class="error-container-cdiferentes" style="margin-top: 0px; margin-left: 5%;">
                            <span style="color: rgba(255, 0, 0, 0.993); font-size: 14px;">
                                Las contraseñas no coinciden. Asegúrate de introducir la misma contraseña.
                            </span>
                        </div>

                    </div>

                    <button mat-raised-button class="login-btn" type="submit" (click)="continuar()">Aceptar</button>
                </form>
            </mat-card-content>
        </mat-card>
    </body>
</html>

